import api from "./api";

const crmService = {
  getAvailability: async () => {
    const { data } = await api.get("/crm/availability");
    return data;
  },

  startDealConversation: async (dealId, payload = {}) => {
    const { data } = await api.post(
      `/crm/deals/${dealId}/conversation`,
      payload,
    );
    return data;
  },

  listTicketDeals: async (ticketId) => {
    const { data } = await api.get(`/crm/tickets/${ticketId}/deals`);
    return data;
  },

  createDealFromTicket: async (ticketId, payload) => {
    const { data } = await api.post(`/crm/tickets/${ticketId}/deals`, payload);
    return data;
  },

  listDealTickets: async (dealId) => {
    const { data } = await api.get(`/crm/deals/${dealId}/tickets`);
    return data;
  },

  linkDealTicket: async (dealId, ticketId) => {
    const { data } = await api.post(`/crm/deals/${dealId}/tickets`, {
      ticketId,
    });
    return data;
  },

  unlinkDealTicket: async (dealId, ticketId) => {
    const { data } = await api.delete(
      `/crm/deals/${dealId}/tickets/${ticketId}`,
    );
    return data;
  },

  listPipelines: async (params = {}) => {
    const { data } = await api.get("/crm/pipelines", { params });
    return data;
  },

  getPipeline: async (pipelineId) => {
    const { data } = await api.get(`/crm/pipelines/${pipelineId}`);
    return data;
  },

  createPipeline: async (payload) => {
    const { data } = await api.post("/crm/pipelines", payload);
    return data;
  },

  updatePipeline: async (pipelineId, payload) => {
    const { data } = await api.put(`/crm/pipelines/${pipelineId}`, payload);
    return data;
  },

  deletePipeline: async (pipelineId) => {
    const { data } = await api.delete(`/crm/pipelines/${pipelineId}`);
    return data;
  },

  createStage: async (pipelineId, payload) => {
    const { data } = await api.post(
      `/crm/pipelines/${pipelineId}/stages`,
      payload,
    );
    return data;
  },

  updateStage: async (stageId, payload) => {
    const { data } = await api.put(`/crm/stages/${stageId}`, payload);
    return data;
  },

  deleteStage: async (stageId) => {
    const { data } = await api.delete(`/crm/stages/${stageId}`);
    return data;
  },

  listDeals: async (params = {}) => {
    const { data } = await api.get("/crm/deals", { params });
    return data;
  },

  getDeal: async (dealId) => {
    const { data } = await api.get(`/crm/deals/${dealId}`);
    return data;
  },

  createDeal: async (payload) => {
    const { data } = await api.post("/crm/deals", payload);
    return data;
  },

  updateDeal: async (dealId, payload) => {
    const { data } = await api.put(`/crm/deals/${dealId}`, payload);
    return data;
  },

  deleteDeal: async (dealId) => {
    const { data } = await api.delete(`/crm/deals/${dealId}`);
    return data;
  },

  moveDealStage: async (dealId, payload) => {
    const { data } = await api.post(`/crm/deals/${dealId}/stage`, payload);
    return data;
  },

  registerDealOutcome: async (dealId, payload) => {
    const { data } = await api.post(`/crm/deals/${dealId}/outcome`, payload);
    return data;
  },

  listActivities: async (dealId) => {
    const { data } = await api.get(`/crm/deals/${dealId}/activities`);
    return data;
  },

  createActivity: async (dealId, payload) => {
    const { data } = await api.post(`/crm/deals/${dealId}/activities`, payload);
    return data;
  },

  updateActivity: async (activityId, payload) => {
    const { data } = await api.put(`/crm/activities/${activityId}`, payload);
    return data;
  },

  deleteActivity: async (activityId) => {
    const { data } = await api.delete(`/crm/activities/${activityId}`);
    return data;
  },

  searchContacts: async (searchParam = "") => {
    const { data } = await api.get("/contacts", { params: { searchParam } });
    return data?.contacts || [];
  },

  listUsers: async () => {
    const { data } = await api.get("/users/list");
    return data || [];
  },
};

export default crmService;
